import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-auto">
      <div className="px-4 sm:px-6 lg:px-8 py-4">
        <p className="text-center text-sm text-gray-600">
          &copy; {new Date().getFullYear()} New Axis Labs Limited. Made with ❤️ for your special moments.
        </p>
      </div>
    </footer>
  );
};

export default Footer;